"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const link_1 = __importDefault(require("next/link"));
const image_1 = __importDefault(require("next/image"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_button_1 = __importDefault(require("@motorata/base-ui.components.atoms.button"));
const base_ui_utils_date_1 = require("@motorata/base-ui.utils.date");
const base_ui_utils_string_1 = require("@motorata/base-ui.utils.string");
const ArticleBlock = ({ type = "column", slug, title, image, readingTime, date, lead, }) => {
    return (react_1.default.createElement(link_1.default, { href: `/artykul/${slug}` },
        react_1.default.createElement(Wrapper, { type: type },
            react_1.default.createElement(ImageWrapper, { className: "image" },
                image && (react_1.default.createElement(image_1.default, { objectFit: "cover", width: "720", height: "405", alt: `Zdjęcie artykułu ${title}`, src: image })),
                react_1.default.createElement(HoverWrapper, { className: "hover" },
                    react_1.default.createElement(base_ui_components_atoms_typography_1.P, { color: "white", margin: "0" }, "Zobacz wi\u0119cej"))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(base_ui_components_atoms_typography_1.LabelH2, { margin: "0" }, (0, base_ui_utils_string_1.replaceHtmlSpecialCharacters)(title)),
                    react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { marginTop: "XS", marginBottom: "S" },
                        react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { marginRight: "XS", type: "third" },
                            readingTime,
                            " min"),
                        date && (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { marginRight: "XS", type: "third" }, (0, base_ui_utils_date_1.formatDate)(date)))),
                    react_1.default.createElement(base_ui_components_atoms_typography_1.P, { small: true }, lead)),
                react_1.default.createElement(base_ui_components_atoms_button_1.default, { padding: "0", type: "third" }, "Zobacz wi\u0119cej")))));
};
exports.default = ArticleBlock;
const HoverWrapper = styled_components_1.default.div `
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.primary};
  opacity: 0;
  transition: opacity 0.3s;
`;
const ImageWrapper = styled_components_1.default.div `
  position: relative;
  overflow: hidden;

  img {
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
const Wrapper = styled_components_1.default.div `
  ${({ type }) => type === "column" &&
    (0, styled_components_1.css) `
      display: flex;
      flex-direction: column;

      > div {
        padding: 1rem 0;
      }

      .image {
        border-radius: 10px;
        padding-bottom: 50%;
        display: block;
        background: rgba(0, 0, 0, 0.08);
        flex: 1 1;
        margin-bottom: ${({ theme }) => theme.space.S};
        height: max-content;
      }

      @media (min-width: 800px) {
        h3 {
          font-size: ${({ theme }) => theme.font.XXL};
        }
      }
    `};

  ${({ type }) => type === "row" &&
    (0, styled_components_1.css) `
      display: grid;
      grid-template-columns: 1fr 2fr;
      grid-gap: ${({ theme }) => theme.space.M};

      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .image {
        width: 100%;
        height: 0;
        background: rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        padding-bottom: 75%;
      }

      @media (max-width: 800px) {
        grid-template-columns: 1fr;
      }
    `};

  &:hover {
    .hover {
      opacity: 0.75;
    }
  }
`;
//# sourceMappingURL=ArticleBlock.js.map